// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"12ff5d23","316":"5db2b28e","453":"5e4fca4d","865":"d8b5756e"}[chunkId] + ".chunk.js";
};